import * as React from 'react';

export interface WizardStep {
  label: string;
  description?: string;
}

export interface WizardStepContextType {
  activeStep: number;
  totalSteps: number;
  steps: WizardStep[];
  goToNext: () => void;
  goToPrev: () => void;
  isFirstStep: boolean;
  isLastStep: boolean;
  setFooterContent: (stepIndex: number, content: React.ReactNode) => void;
}

export const WizardStepContext = React.createContext<WizardStepContextType | undefined>(undefined);
